var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCreativeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.000488281,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F4EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4444 8.5H10.5556C9.69645 8.5 9 9.19645 9 10.0556V20.9444C9 21.8036 9.69645 22.5 10.5556 22.5H21.4444C22.3036 22.5 23 21.8036 23 20.9444V10.0556C23 9.19645 22.3036 8.5 21.4444 8.5Z",
    stroke: "#7434DB",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.278 13.9447C13.9223 13.9447 14.4447 13.4223 14.4447 12.778C14.4447 12.1337 13.9223 11.6113 13.278 11.6113C12.6337 11.6113 12.1113 12.1337 12.1113 12.778C12.1113 13.4223 12.6337 13.9447 13.278 13.9447Z",
    stroke: "#7434DB",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9991 17.8332L19.1102 13.9443L10.5547 22.4999",
    stroke: "#7434DB",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCreativeIcon);
export default __webpack_public_path__ + "static/media/add_creative_icon.715726f48a0c9cbd88fb7c9d17170890.svg";
export { ForwardRef as ReactComponent };